import _regeneratorRuntime from 'babel-runtime/regenerator';

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import get from 'lodash/get';
import uniqueId from 'lodash/uniqueId';

export var sleep = function sleep(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
};

export var humanizeBytes = function humanizeBytes(size) {
  var i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
};

export var clipName = function clipName(text) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 35;
  return text.length < size ? text : text.slice(0, size - 13) + '...' + text.slice(text.length - size - 25);
};

export var filterById = function filterById(items, id) {
  return items.filter(function (item) {
    return get(item, 'id') !== id;
  });
};

export var fileToBase64 = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var reader;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reader = new FileReader();
            return _context.abrupt('return', new Promise(function (resolve, reject) {
              reader.onerror = function () {
                reader.abort();
                reject(new DOMException('Problem parsing input file.'));
              };
              reader.onloadend = function () {
                resolve(reader.result);
              };
              reader.readAsDataURL(file);
            }));

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fileToBase64(_x2) {
    return _ref.apply(this, arguments);
  };
}();

export var getFileObject = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
    var path, name, type, size, id, parsed;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            path = file.path, name = file.name, type = file.type, size = file.size;
            id = uniqueId('file-');
            _context2.next = 4;
            return fileToBase64(file);

          case 4:
            parsed = _context2.sent;
            return _context2.abrupt('return', { path: path, name: name, type: type, size: size, id: id, parsed: parsed });

          case 6:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function getFileObject(_x3) {
    return _ref2.apply(this, arguments);
  };
}();